import React, { useEffect } from 'react';
import {
  Box, Button, Typography, Card, CardContent, Link
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const HtmlPreview = ({
  currentPreviewUrl,
  loading,
  fetchSuccess,
  url,
  contentRef,
  shadowRef,
  history,
  onBack,
  htmlContent
}) => {
  useEffect(() => {
    if (shadowRef.current) {
      let shadow;
      if (shadowRef.current.shadowRoot) {
        shadow = shadowRef.current.shadowRoot;
        shadow.innerHTML = ''; // Always clear
      } else {
        shadow = shadowRef.current.attachShadow({ mode: 'open' });
      }
      // Only inject <body> content
      if (htmlContent) {
        shadow.innerHTML = htmlContent;
      }
      // Only log the action, not the full HTML
      console.log('Injected into Shadow DOM');
    }
  }, [htmlContent]);

  return (
    <Card 
      elevation={0}
      sx={{ 
        borderRadius: 3, 
        minHeight: 800, 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04)'
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 3 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Box display="flex" alignItems="center" mb={2}>
          {history.length > 0 && (
            <Button onClick={onBack} size="small" variant="outlined" sx={{ mr: 2 }}>
              Back
            </Button>
          )}
          {loading && (
            <Typography variant="body2" sx={{ color: '#1976d2' }}>Loading...</Typography>
          )}
        </Box>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="subtitle1" fontWeight={600} sx={{ flexGrow: 1 }}>Fetched Content</Typography>
          {fetchSuccess && (
            <Link href={url} target="_blank" rel="noopener" underline="hover" sx={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
              <OpenInNewIcon fontSize="small" sx={{ mr: 0.5 }} /> Open
            </Link>
          )}
        </Box>
        <Box
          className="fetched-html-content"
          ref={el => { contentRef.current = el; shadowRef.current = el; }}
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            minHeight: 300,
            maxHeight: 800,
            overflow: 'auto',
            bgcolor: '#f8fafc',
            p: 2,
            flex: 1,
            position: 'relative'
          }}
        >
          {loading ? (
            <Typography variant="body2" sx={{ color: '#1976d2', textAlign: 'center', mt: 4 }}>
              Loading content...
            </Typography>
          ) : !currentPreviewUrl ? (
            <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', mt: 4 }}>
              Enter a URL and click Get HTML to preview content here.
            </Typography>
          ) : !fetchSuccess ? (
            <Typography variant="body2" sx={{ color: '#d32f2f', textAlign: 'center', mt: 4 }}>
              Failed to fetch content. Please try again.
            </Typography>
          ) : null}
          {/* Shadow DOM will render here if currentPreviewUrl is set and fetchSuccess */}
        </Box>
      </CardContent>
    </Card>
  );
};

export default HtmlPreview; 